import { createSelector } from 'reselect';
import { IRootState } from 'store';

export const selectorGetActiveScratchLinkConfigDeviceProfile = createSelector(
    (state: IRootState) => ({ 
        hardwareModeAutoDetected: state.project.hardwareModeAutoDetected, 
        scratchlinkConfig: state.project.scratchlinkConfig 
    }), 
    ({ hardwareModeAutoDetected, scratchlinkConfig }): any => scratchlinkConfig.deviceProfiles.find((deviceProfile: any) => deviceProfile.profile === hardwareModeAutoDetected)
);